"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSaveAsNewButton = exports.useSaveAsNewButtonProps = exports.selectIsSaveAsNewButtonVisible = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var model_1 = require("../../../../../model");
var selectors_1 = require("../selectors");
var toolkit_1 = require("@reduxjs/toolkit");
/**
 * @internal
 */
exports.selectIsSaveAsNewButtonVisible = toolkit_1.createSelector(model_1.selectDashboardEditModeDevRollout, model_1.selectEnableKPIDashboardSaveAsNew, model_1.selectIsSaveAsNewButtonHidden, selectors_1.selectCanEnterEditModeAndIsLoaded, model_1.selectCanCreateAnalyticalDashboard, model_1.selectIsExport, model_1.selectIsReadOnly, function (isEditModeDevRollout, isSaveAsNewEnabled, isSaveAsButtonHidden, isDashboardEditable, canCreateDashboard, isExport, isReadOnly) {
    /*
     * The reasoning behind this condition is as follows. Do not show separate Save As button if:
     *
     * 0.  edit mode rollout flag enabled
     *
     * 1.  The feature is not enabled or
     * 2.  If is disabled by config
     * 3.  If the dashboard can be edited; in this case, the save as option is part of the dropdown menu;
     *     it is somewhat more hidden
     * 4.  dashboard is not in export mode
     * 5.  If the user cannot create dashboards - e.g. does not have permissions to do so (is viewer for example).
     * 6.  If the dashboard is in read-only mode.
     */
    return (isEditModeDevRollout &&
        isSaveAsNewEnabled &&
        !isSaveAsButtonHidden &&
        !isDashboardEditable &&
        !isExport &&
        canCreateDashboard &&
        !isReadOnly);
});
/**
 * @internal
 */
function useSaveAsNewButtonProps() {
    var dashboardDispatch = model_1.useDashboardDispatch();
    var isVisible = model_1.useDashboardSelector(exports.selectIsSaveAsNewButtonVisible);
    var onSaveAsNewClick = react_1.useCallback(function () {
        dashboardDispatch(model_1.uiActions.openSaveAsDialog());
    }, [dashboardDispatch]);
    return {
        isVisible: isVisible,
        onSaveAsNewClick: onSaveAsNewClick,
    };
}
exports.useSaveAsNewButtonProps = useSaveAsNewButtonProps;
/**
 * @internal
 */
function DefaultSaveAsNewButton(_a) {
    var isVisible = _a.isVisible, onSaveAsNewClick = _a.onSaveAsNewClick;
    var intl = react_intl_1.useIntl();
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement(sdk_ui_kit_1.Button, { className: "gd-button-secondary s-save_as_new_button", value: intl.formatMessage({ id: "save.as.new" }), onClick: onSaveAsNewClick }));
}
exports.DefaultSaveAsNewButton = DefaultSaveAsNewButton;
//# sourceMappingURL=DefaultSaveAsNewButton.js.map